module.exports = ".display {\n  display: block !important; }\n\n.display_standart {\n  display: none; }\n"